const extraData = {
	expertise: [
		"Addiction",
		"Video games and internet addiction",
		"Polyamory and alternative relationships",
		"Adoption",
		"Anger Management",
		"Body Positivity",
		"Chronic Pain",
		"Coping Skills",
		"Depression",
		"Divorce",
		"Domestic Violence",
		"Family Conflict",
		"Loss/Grief",
		"Internet Addiction",
		"Life Transitions",
		"Marital and Premarital Relationships",
		"Parenting",
		"Racial Identity",
		"Self-Harming",
		"Stress",
		"Suicidal Ideation",
	],
	treatmentApproaches: [
		"Acceptance and Commitment (ACT) Therapy",
		"Cognitive Behavioral (CBT) Therapy",
		"Dialectical Behavior (DBT) Therapy",
		"EMDR Therapy",
		"Gottman Method Couples Therapy",
		"Internal Family Systems (IFS) Couples Therapy",
		"Motivational Interviewing",
		"Narrative Therapy",
		"Solution Focused Brief (SFBT) Therapy",
		"Somatic Therapy",
		"Trauma Focused",
	],
	ageGroups: ["Preteens (11-13 yrs)", "Teens", "Adults", "Seniors"],
	audience: ["Couples", "Family", "Individual", "LGBTQ2IA+"],
};

export default extraData;
